import Bugsnag from "@bugsnag/js";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import axiosInstance from "../axiosInstance";
import { setAreNotificationsPaused } from "../Store/Actions";
import { ADD_TOAST } from "../Store/Actions/types";
import URL from "../urls";

const useNotificationStatus = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const getNotificationStatus = async () => {
      try {
        const response = await axiosInstance.get(
          URL.getNotificationsPausedStatus
        );
        const areNotificationsPaused =
          !!response?.data?.data?.notifications_paused;
        dispatch(setAreNotificationsPaused(areNotificationsPaused));
      } catch (error) {
        Bugsnag.notify(error);
        dispatch({
          type: ADD_TOAST,
          payload: {
            msg: "Failed to fetch notification status",
            appearance: "error",
          },
        });
      }
    };
    getNotificationStatus();
  }, [dispatch]);
};

export default useNotificationStatus;
